import { AmbientLight, MathUtils, Scene, Vector3 } from "three";
import { CharcterOxxo } from "../objects/CharacterOxxo";
import { CameraController } from "../../componets3D/CameraController";
import { MouseEvents } from "../../componets3D/MouseEvents";
import { ButtonScreenPoint, CashRegister, MapOxxoTopicOne, MonitorIntroTopicTwo } from "../objects/Topics";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";

export class SceneTopicTwo extends Scene {
	constructor(loadingManager, container, render, character = new CharcterOxxo(), enviro) {
		super();
		this.characterSelected = character;
		this.environment = enviro;
		this.camera = new CameraController();
		this.loadingManager = loadingManager;
		this.mouseEvents = new MouseEvents(container, render, this.camera, this);
		this.light()
		this.create();
		this.listeners()
		this.renderAnimations();
	}

	create() {
		this.map = new MapOxxoTopicOne(this.loadingManager);
		this.add(this.map);
		this.add(this.characterSelected)

		this.monitorTopic = new MonitorIntroTopicTwo(this.loadingManager)
		this.cashRegister = new CashRegister(this.loadingManager)
		this.buttonScreenPoint = new ButtonScreenPoint(this.loadingManager)

	}

	light() {
		this.ambient = new AmbientLight();
		this.ambient.color.set(0xffffff);
		this.ambient.intensity = 1;
		this.add(this.ambient);
	}

	characterMoveInitScene() {
		this.characterSelected.onAnimateSaludo();
		this.characterSelected.visible = true;
		this.characterSelected.position.set(-10.5846, -0.9809, -1.9341);
		this.characterSelected.rotation.set(0, -1.5145, 0);
	}



	sceneActivityOneState() {
		this.characterMoveInitScene()
		this.mouseEvents.disposeInteractions()
		this.mouseEvents.objectsToValue = []
		this.mouseListeners()


		this.monitorTopic.visible = true
		this.monitorTopic.initMonitor()
		this.add(this.monitorTopic)


		ObserverEmitter.on(EVENTS.tema7.topic1.actScene, (step = "") => {
			switch (step) {
				case "move_client_1":
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.moveCameraToPoint(new Vector3(-7.0293, -0.1354, -0.8723), 1, new Vector3(-8.026, -0.213, -0.876), () => {
					});
					break;

				case "move_desktop_1":
					this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
						this.characterSelected.visible = true
					});
					break;

				case "move_monitor_1":
					this.characterSelected.visible = false
					this.camera.moveCameraToPoint(new Vector3(-12.2665, 0.0093, 2.7979), 1, new Vector3(-10.716, 0, 2.752), () => {
					});
					break;

				case "move_desktop_2":
					this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
						this.characterSelected.visible = true
					});
					break;

				default:
					this.monitorTopic.visible = false
					break;
			}
		})

	}

	sceneActivityTwoState() {
		this.characterMoveInitScene()
		this.mouseEvents.disposeInteractions()
		this.mouseEvents.objectsToValue = []
		this.mouseListeners()

		this.cashRegister.visible = true
		this.cashRegister.position.set(-11.5572, -1.0241, -2.2939)
		this.add(this.cashRegister)

		ObserverEmitter.on(EVENTS.tema7.topic2.actScene, (step = "") => {
			switch (step) {
				case "cash_register":
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.moveCameraToPoint(new Vector3(-11.9531, -0.6635, -2.1119), 1, new Vector3(-11.6, -1.634, -2.114), () => {
						this.cashRegister.onAnimationMovePosition(this.cashRegister, { x: -11.888, y: -1.0241, z: -2.2939 }, 1, () => {
							ObserverEmitter.emit(EVENTS.tema7.topic2.listenScene, "cash_register")
							this.camera.control.maxDistance = 1.2
						})
					});
					break;

				case "move_client_1":
					this.camera.moveCameraToPoint(new Vector3(-7.0293, -0.1354, -0.8723), 1, new Vector3(-8.026, -0.213, -0.876), () => {
					});
					break;

				default:
					this.cashRegister.visible = false
					break;
			}
		})
	}

	sceneActivityThreeState() {
		this.characterMoveInitScene()
		this.mouseEvents.disposeInteractions()
		this.mouseEvents.objectsToValue = []
		this.mouseListeners()
	}

	sceneActivityFourState() {
		this.characterMoveInitScene()
		this.mouseEvents.disposeInteractions()
		this.mouseEvents.objectsToValue = []

		this.monitorTopic.visible = true
		this.monitorTopic.initMonitor()
		this.add(this.monitorTopic)

		this.buttonScreenPoint.visible = true
		// this.buttonScreenPoint.scale.set(0.0339, 0.0339, 0.0339)
		this.buttonScreenPoint.rotation.y = -1.4263
		this.buttonScreenPoint.position.set(-11.6791, 0.1432, 2.7124)
		this.add(this.buttonScreenPoint)

		ObserverEmitter.on(EVENTS.tema7.topic2.actScene, (step = "") => {
			switch (step) {
				case "move_monitor_1":
					this.characterSelected.visible = false
					this.camera.moveCameraToPoint(new Vector3(-12.2665, 0.0093, 2.7979), 1, new Vector3(-10.716, 0, 2.752), () => {
						this.buttonScreenPoint.onAnimationOpacity()
						this.mouseEvents.objectsToValue = [this.buttonScreenPoint]
						this.mouseListeners()
					});
					break;
				default:
					this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
						this.monitorTopic.visible = false
						this.buttonScreenPoint.visible = false
					})
					break;
			}
		})
	}


	listeners() {

	}

	activeAudio() {
		ObserverEmitter.emit(EVENTS.audioInitByTopic)
	}

	ActivitiSelected(activity) {
		switch (activity) {
			case 0:
				this.camera.moveCameraToPoint(new Vector3(-12.4058, -0.5368, 4.338), 2, new Vector3(-11.992, -1.74, -9.102), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.control.minDistance = 13.5;
					this.camera.control.maxDistance = 13.5;
					this.camera.control.enablePan = false;

					this.activeAudio()

				})
				break;
			case 1:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.ennablePan = false;
					this.camera.control.enableZoom = false;

					this.characterSelected.visible = false
					this.activeAudio()

					this.sceneActivityOneState();
				});
				break;
			case 2:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.ennablePan = false;

					this.characterSelected.visible = false
					this.activeAudio()

					this.sceneActivityTwoState();
				});
				break;
			case 3:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.ennablePan = false;

					this.characterSelected.visible = false
					this.activeAudio()

					this.sceneActivityThreeState();
				});
				break;

			case 4:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.ennablePan = false;

					this.characterSelected.visible = false
					this.activeAudio()

					this.sceneActivityFourState();
				});
				break;
			default:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.ennablePan = false;

					this.characterSelected.visible = false

				});
				break;
		}
	}

	mouseListeners() {
		this.mouseEvents.onPointerUp((interactions) => {
			if (interactions[0]) {
				const name = interactions[0].object.name;
				const selectObjects = {
					CircleLittle: "corte_z",
					CircleBig: "corte_z"
				}
				if (!selectObjects[name]) {
					return
				}
				ObserverEmitter.emit(EVENTS.tema7.topic2.listenScene, selectObjects[name]);
			}
		});
	}

	renderAnimations(delta) {
	}
}
